import React, { useRef, useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";

interface OverflowTooltipProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
}

export const OverflowTooltip = (props: OverflowTooltipProps) => {
  const { text, className } = props;
  const [isOverflowed, setOverflowed] = useState(false);
  const textContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textContainer.current) {
      setOverflowed(
        textContainer.current.scrollWidth > textContainer.current.clientWidth,
      );
    }
  }, [textContainer]);

  return (
    <Tooltip title={text} disableHoverListener={!isOverflowed}>
      <div
        ref={textContainer}
        className={`truncate ${className}`}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text}
      </div>
    </Tooltip>
  );
};
